module.exports = __webpack_public_path__ + "img/arrow-right.ed8ff3d6.svg";